export default __webpack_public_path__ + "static/media/slider3.558482c1.jpg";